import { Sparkles, Gavel, CircleHelp, ListOrdered } from "lucide-react";
import { fmtTime } from "@/lib/api";
import { useApp } from "@/lib/i18n";

export const TsLink = ({ t, onSeek }) =>
  t == null ? null : (
    <button onClick={() => onSeek?.(t)} className="ml-2 rounded-md bg-violet-50 px-1.5 py-0.5 font-mono text-[11px] font-semibold text-violet-700 hover:bg-violet-100" data-testid="source-ts-link">
      {fmtTime(t)}
    </button>
  );

const Section = ({ icon: Icon, title, children, id }) => (
  <div className="mt-7" data-testid={`summary-section-${id}`}>
    <h3 className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-slate-500"><Icon size={14} /> {title}</h3>
    <div className="mt-3 space-y-2">{children}</div>
  </div>
);

const Item = ({ children }) => (
  <div className="flex gap-3 text-sm leading-relaxed text-slate-700"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-violet-500" /> <div>{children}</div></div>
);

export const SummaryTab = ({ notes, onSeek }) => {
  const { L } = useApp();
  const c = notes?.content || {};
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
      <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-violet-700"><Sparkles size={14} /> {L("Ringkasan", "Summary")}</div>
      <p className="mt-3 text-base leading-relaxed text-slate-800" data-testid="meeting-summary">{c.summary}</p>
      {c.agenda?.length > 0 && (
        <Section icon={ListOrdered} title={L("Agenda", "Agenda")} id="agenda">
          {c.agenda.map((a, i) => <Item key={i}>{a.title}<TsLink t={a.start} onSeek={onSeek} /></Item>)}
        </Section>
      )}
      {c.key_points?.length > 0 && (
        <Section icon={Sparkles} title={L("Perkara utama", "Key points")} id="key-points">
          {c.key_points.map((k, i) => <Item key={i}>{k}</Item>)}
        </Section>
      )}
      {c.decisions?.length > 0 && (
        <Section icon={Gavel} title={L("Keputusan", "Decisions")} id="decisions">
          {c.decisions.map((d, i) => <Item key={i}>{d.text}<TsLink t={d.start} onSeek={onSeek} /></Item>)}
        </Section>
      )}
      {c.open_issues?.length > 0 && (
        <Section icon={CircleHelp} title={L("Isu terbuka", "Open issues")} id="open-issues">
          {c.open_issues.map((k, i) => <Item key={i}>{k}</Item>)}
        </Section>
      )}
    </div>
  );
};
